import { browserName, isAndroid } from 'react-device-detect';

export const redirectToDefaultBrowserIfInsideWebViewAndroid = (browser = 'Facebook') => {
	if (window) {
		if (browserName === browser && isAndroid) {
			window.location = `intent:${window.location}#Intent;end`;
		}
	}
};
